import { render, staticRenderFns } from "./setRole.vue?vue&type=template&id=aef5621e&scoped=true&"
import script from "./setRole.vue?vue&type=script&lang=ts&"
export * from "./setRole.vue?vue&type=script&lang=ts&"
import style0 from "./setRole.vue?vue&type=style&index=0&id=aef5621e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef5621e",
  null
  
)

export default component.exports